import { marcaConstantes } from './types';
import { marcaService , alertService} from '@services';


export const marcaActions = {
    getAllWithPathImgAndActive,
    loadComboBoxMarca,
    selectedMarca,
    removeSelectedMarca
};


function getAllWithPathImgAndActive() {
    return dispatch => {
        dispatch(request());

        document.querySelector( 'body' ).classList.remove( "loaded" );

        return new Promise((resolve, reject) => {
            marcaService.getAllWithPathImgAndActive()
            .then(
                marcas => { 
                    dispatch(success(marcas))
                    resolve(marcas); // respuesta correcta
                },
                error => {
                    alertService.error(error);
                    reject(error)
                }
            )
            .finally(() => {
                document.querySelector( 'body' ).classList.add( "loaded" );
            });
        })

        
    };

    function request() { return { type: marcaConstantes.GET_ALL_WITH_PATH_IMG_AND_ACTIVE_REQUEST } }
    function success(marcas) { return { type: marcaConstantes.GET_ALL_WITH_PATH_IMG_AND_ACTIVE_SUCCESS, marcas } }

}

function loadComboBoxMarca() {
    return dispatch => {
        dispatch(request());

        return new Promise((resolve, reject) => {
            marcaService.loadComboBoxMarca()
            .then(
                marcas => { 
                    dispatch(success(marcas))
                    resolve(marcas); // respuesta correcta
                },
                error => {
                    alertService.error(error);
                    reject(error)
                }
            )
        })

        
    };

    function request() { return { type: marcaConstantes.GET_ALL_WITH_PATH_IMG_AND_ACTIVE_REQUEST } }
    function success(marcas) { return { type: marcaConstantes.GET_ALL_WITH_PATH_IMG_AND_ACTIVE_SUCCESS, marcas } }

}



function selectedMarca(marca) {
    return dispatch => {
            dispatch(success(marca));  
        }   
    function success(marca) { return { type: marcaConstantes.SELECTED_MARCA_SUCCESS, marca } }
}

function removeSelectedMarca() {
    return dispatch => {
            dispatch(success());  
        }   
    function success() { return { type: marcaConstantes.REMOVE_SELECTED_MARCA_SUCCESS } }
}